// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== 1. Hero Section ===== */
.Servicios-360_heroSection__ThmY- {
  position: relative;
  text-align: center;
  padding: 100px 5%;
  color: var(--textoBlanco);
  overflow: hidden;
}

.Servicios-360_heroBackground__iAYV7 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2;
}

.Servicios-360_heroOverlay__3gg2w {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: -1;
}

.Servicios-360_heroSection__ThmY- h1 {
  font-size: 52px;
  font-weight: 800;
  color: var(--textoBlanco);
  line-height: 1.2;
}

.Servicios-360_heroSection__ThmY- p {
  font-size: 35px;
  max-width: bold;
  margin: 20px auto 40px auto;
  color: #e0e0e0;
}

.Servicios-360_ctaButton__UVQXx {
  background-color: var(--naranja);
  color: var(--textoBlanco);
  padding: 1rem 3rem;
  border-radius: 5px;
  font-weight: 700;
  font-size: 18px;
  transition: all 0.3s ease;
}
.Servicios-360_ctaButton__UVQXx:hover {
  background-color: var(--azul);
}

/* ===== 2. Plan Section ===== */
.Servicios-360_planSection__iUXBW {
  padding: 80px 5%;
  background-color: #02abe7;
  text-align: center;
}
.Servicios-360_planContainer__lM\\+Mp {
  max-width: 900px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}
.Servicios-360_planSection__iUXBW h2 {
  font-size: 26px;
  text-align: left;
  font-weight: 700;
  margin-bottom: 15px;
  color: #ffffff;
}
.Servicios-360_planSection__iUXBW p {
  font-size: 18px;
  text-align: left;
  line-height: 1.6;
  color: #ffffff;
}

/* ===== 3. Metodología Section ===== */
.Servicios-360_methodologySection__RXGfd {
  padding: 100px 5%;
  background-color: #ffffff;
}
.Servicios-360_methodologyContainer__LTWGw {
  max-width: 100%;
  margin: 0 auto;
}
.Servicios-360_sectionTitle__ItAnm {
  text-align: center;
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 60px;
  color: var(--textoNegro);
}

.Servicios-360_methodologyList__aOf8a {
  list-style: none;
  padding: 0;
  display: flex; 
  gap: 20px;
  overflow-x: 1px;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
}

.Servicios-360_stepItem__hdAMy {
  flex: 1 1 200px; 
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  padding: 30px;
  text-align: left;
  position: relative;
  scroll-snap-align: start; 
  border-top: 5px solid var(--azulCielo);
  transition: transform 0.2s ease-in-out;
}

.Servicios-360_stepItem__hdAMy:hover {
    transform: translateY(-5px); 
}

.Servicios-360_stepNumber__6\\+G1e {
  position: absolute;
  top: -20px; 
  left: 30px;
  width: 40px;
  height: 40px;
  background-color: #02abe7;
  color: var(--textoBlanco);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 18px;
  border: 3px solid #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.Servicios-360_stepItem__hdAMy h3 {
  font-size: 20px;
  font-weight: 700;
  margin-top: 30px; 
  margin-bottom: 10px;
  color: var(--textoNegro);
}
.Servicios-360_stepItem__hdAMy p {
  font-size: 15px;
  line-height: 1.6;
  color: #666;
}

/* ===== 4. Resultados Section ===== */
.Servicios-360_resultsSection__MlkS\\+ {
  padding: 70px 5%;
  background-color: var(--azulCielo);
}
.Servicios-360_resultsGrid__FbpPc {
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}
.Servicios-360_resultItem__jXrU- {
  text-align: center;
}
.Servicios-360_resultItem__jXrU- svg {
  width: 50px;
  height: 50px;
  margin-bottom: 15px;
}
.Servicios-360_resultItem__jXrU- figcaption {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

/* ======================================= */
/* ===== MEDIA QUERY PARA MÓVILES ===== */
/* ======================================= */
@media (max-width: 981px) {
    .Servicios-360_ctaButton__UVQXx {
        background-color: var(--naranja);
        color: var(--textoBlanco);
        padding: 1rem 2rem;
        border-radius: 5px;
        font-weight: 700;
        font-size: 15px;
        transition: all 0.3s ease;
    }
  .Servicios-360_heroSection__ThmY- h1 { font-size: 36px; }
  .Servicios-360_planContainer__lM\\+Mp { grid-template-columns: 1fr; }
  .Servicios-360_resultsGrid__FbpPc { grid-template-columns: 1fr 1fr; gap: 40px; }
  .Servicios-360_sectionTitle__ItAnm { font-size: 28px; }

  .Servicios-360_methodologyList__aOf8a {
    flex-direction: column;
    gap: 0; 
    border-left: 3px solid var(--azulCielo); 
    overflow-x: 1px;
  }

  .Servicios-360_stepItem__hdAMy {
    flex: none;
    width: auto;
    margin-bottom: 40px; 
    padding-left: 40px;
    box-shadow: none; 
    border-top: none;
    background-color: transparent; 
  }

  .Servicios-360_stepNumber__6\\+G1e {
    position: absolute;
    left: -21.5px;
    top: 0;
    border: 3px solid #f7f7f7; 
    box-shadow: none;
  }

  .Servicios-360_stepItem__hdAMy h3 {
    margin-top: 0; 
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Servicios-360.module.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,SAAS;EACT,eAAe;EACf,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,4CAA4C;AAC5C,yCAAyC;AACzC,4CAA4C;AAC5C;IACI;QACI,gCAAgC;QAChC,yBAAyB;QACzB,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,yBAAyB;IAC7B;EACF,uCAAkB,eAAe,EAAE;EACnC,uCAAiB,0BAA0B,EAAE;EAC7C,oCAAe,8BAA8B,EAAE,SAAS,EAAE;EAC1D,qCAAgB,eAAe,EAAE;;EAEjC;IACE,sBAAsB;IACtB,MAAM;IACN,uCAAuC;IACvC,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,MAAM;IACN,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":["/* ===== 1. Hero Section ===== */\n.heroSection {\n  position: relative;\n  text-align: center;\n  padding: 100px 5%;\n  color: var(--textoBlanco);\n  overflow: hidden;\n}\n\n.heroBackground {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: -2;\n}\n\n.heroOverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: -1;\n}\n\n.heroSection h1 {\n  font-size: 52px;\n  font-weight: 800;\n  color: var(--textoBlanco);\n  line-height: 1.2;\n}\n\n.heroSection p {\n  font-size: 35px;\n  max-width: bold;\n  margin: 20px auto 40px auto;\n  color: #e0e0e0;\n}\n\n.ctaButton {\n  background-color: var(--naranja);\n  color: var(--textoBlanco);\n  padding: 1rem 3rem;\n  border-radius: 5px;\n  font-weight: 700;\n  font-size: 18px;\n  transition: all 0.3s ease;\n}\n.ctaButton:hover {\n  background-color: var(--azul);\n}\n\n/* ===== 2. Plan Section ===== */\n.planSection {\n  padding: 80px 5%;\n  background-color: #02abe7;\n  text-align: center;\n}\n.planContainer {\n  max-width: 900px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 40px;\n}\n.planSection h2 {\n  font-size: 26px;\n  text-align: left;\n  font-weight: 700;\n  margin-bottom: 15px;\n  color: #ffffff;\n}\n.planSection p {\n  font-size: 18px;\n  text-align: left;\n  line-height: 1.6;\n  color: #ffffff;\n}\n\n/* ===== 3. Metodología Section ===== */\n.methodologySection {\n  padding: 100px 5%;\n  background-color: #ffffff;\n}\n.methodologyContainer {\n  max-width: 100%;\n  margin: 0 auto;\n}\n.sectionTitle {\n  text-align: center;\n  font-size: 32px;\n  font-weight: 800;\n  margin-bottom: 60px;\n  color: var(--textoNegro);\n}\n\n.methodologyList {\n  list-style: none;\n  padding: 0;\n  display: flex; \n  gap: 20px;\n  overflow-x: 1px;\n  -webkit-overflow-scrolling: touch;\n  scroll-snap-type: x mandatory;\n}\n\n.stepItem {\n  flex: 1 1 200px; \n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  padding: 30px;\n  text-align: left;\n  position: relative;\n  scroll-snap-align: start; \n  border-top: 5px solid var(--azulCielo);\n  transition: transform 0.2s ease-in-out;\n}\n\n.stepItem:hover {\n    transform: translateY(-5px); \n}\n\n.stepNumber {\n  position: absolute;\n  top: -20px; \n  left: 30px;\n  width: 40px;\n  height: 40px;\n  background-color: #02abe7;\n  color: var(--textoBlanco);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 700;\n  font-size: 18px;\n  border: 3px solid #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.stepItem h3 {\n  font-size: 20px;\n  font-weight: 700;\n  margin-top: 30px; \n  margin-bottom: 10px;\n  color: var(--textoNegro);\n}\n.stepItem p {\n  font-size: 15px;\n  line-height: 1.6;\n  color: #666;\n}\n\n/* ===== 4. Resultados Section ===== */\n.resultsSection {\n  padding: 70px 5%;\n  background-color: var(--azulCielo);\n}\n.resultsGrid {\n  max-width: 1000px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 30px;\n}\n.resultItem {\n  text-align: center;\n}\n.resultItem svg {\n  width: 50px;\n  height: 50px;\n  margin-bottom: 15px;\n}\n.resultItem figcaption {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* ======================================= */\n/* ===== MEDIA QUERY PARA MÓVILES ===== */\n/* ======================================= */\n@media (max-width: 981px) {\n    .ctaButton {\n        background-color: var(--naranja);\n        color: var(--textoBlanco);\n        padding: 1rem 2rem;\n        border-radius: 5px;\n        font-weight: 700;\n        font-size: 15px;\n        transition: all 0.3s ease;\n    }\n  .heroSection h1 { font-size: 36px; }\n  .planContainer { grid-template-columns: 1fr; }\n  .resultsGrid { grid-template-columns: 1fr 1fr; gap: 40px; }\n  .sectionTitle { font-size: 28px; }\n\n  .methodologyList {\n    flex-direction: column;\n    gap: 0; \n    border-left: 3px solid var(--azulCielo); \n    overflow-x: 1px;\n  }\n\n  .stepItem {\n    flex: none;\n    width: auto;\n    margin-bottom: 40px; \n    padding-left: 40px;\n    box-shadow: none; \n    border-top: none;\n    background-color: transparent; \n  }\n\n  .stepNumber {\n    position: absolute;\n    left: -21.5px;\n    top: 0;\n    border: 3px solid #f7f7f7; \n    box-shadow: none;\n  }\n\n  .stepItem h3 {\n    margin-top: 0; \n    font-size: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroSection": `Servicios-360_heroSection__ThmY-`,
	"heroBackground": `Servicios-360_heroBackground__iAYV7`,
	"heroOverlay": `Servicios-360_heroOverlay__3gg2w`,
	"ctaButton": `Servicios-360_ctaButton__UVQXx`,
	"planSection": `Servicios-360_planSection__iUXBW`,
	"planContainer": `Servicios-360_planContainer__lM+Mp`,
	"methodologySection": `Servicios-360_methodologySection__RXGfd`,
	"methodologyContainer": `Servicios-360_methodologyContainer__LTWGw`,
	"sectionTitle": `Servicios-360_sectionTitle__ItAnm`,
	"methodologyList": `Servicios-360_methodologyList__aOf8a`,
	"stepItem": `Servicios-360_stepItem__hdAMy`,
	"stepNumber": `Servicios-360_stepNumber__6+G1e`,
	"resultsSection": `Servicios-360_resultsSection__MlkS+`,
	"resultsGrid": `Servicios-360_resultsGrid__FbpPc`,
	"resultItem": `Servicios-360_resultItem__jXrU-`
};
export default ___CSS_LOADER_EXPORT___;
